import { EntityUtils } from '../../../../../record-it-npm-synchro-client/src';
import { ConstructionSite } from './constructionSiteTypes';
export class ConstructionSiteUtils {
  private constructor() {}
  public static keyGetter = (cs: ConstructionSite): string => EntityUtils.getTrackingKey(cs);
  public static displayTextGetter = (cs: ConstructionSite): string => cs.name;
  public static containsSearchText(constructionSite: ConstructionSite, searchText: string): boolean {
    return constructionSite.name.toLocaleLowerCase().includes(searchText.toLocaleLowerCase());
  }
}